<template>
  <div class="login-page d-flex flex-column min-vh-100">
    <div class="logo-wrapper d-flex justify-content-end align-items-center px-4 py-3">
      <img
        src="/img/logo.png"
        alt="Logo"
        class="logo"
      >
    </div>
    <div class="d-flex flex-grow-1 align-items-center justify-content-center px-3">
      <CCard
        class="shadow-sm rounded-5 w-100"
        style="max-width: 480px;"
      >
        <CCardBody class="p-4 p-md-5">
          <CForm class="d-flex flex-column">
            <p class="text-center font-weight-bold mb-4 text-uppercase text-primary">
              Forgot Password?
            </p>
            <CInput
              v-model="formData.email"
              :placeholder="'E-mail'"
              autocomplete="email"
              :add-input-classes="{'is-invalid': hasError('email')}"
              :invalid-feedback="getError('email')"
            >
              <template #append-content>
                <i class="far fa-envelope text-secondary" />
              </template>
            </CInput>
            <CButton
              color="primary"
              class="px-5 mb-3 align-self-center text-uppercase"
              :disabled="!isValidEmail || success"
              @click="forgotPassword"
            >
              Send
            </CButton>
            <router-link
              v-if="!message"
              :to="{ name: 'Login'}"
              class="d-block text-center px-0 font-weight-bold link"
            >
              Back to Login
            </router-link>
            <p
              v-else
              class="text-center text-primary"
            >
              {{ message }}
            </p>
          </CForm>
        </CCardBody>
      </CCard>
    </div>
  </div>
</template>

<script>
import hasApiValidation from "@/mixins/hasApiValidation";
export default {
  name: 'ForgotPassword',
  mixins: [hasApiValidation],
  data() {
    return {
      formData: {
        email: '',
      },
      message: '',
      success: false,
    }
  },
  computed: {
    isValidEmail() {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return re.test(this.formData.email)
    },
  },
  methods: {
    forgotPassword() {
      if (this.success) {
        return
      }
      this.$http.post('/auth/forgot-password', this.formData)
          .then(({data}) => {
            this.message = data.message;
            this.success = true;
            this.$toast.success(data.message);
            this.setErrors({});
            setTimeout(() => {
              this.$router.push({ name: 'Login' });
            }, 2000);
          })
          .catch(({response}) => {
            if (response && response.data.message) {
              this.$toast.error(response.data.message);
            }
            this.setErrors(response.data.errors);
          });
    }
  }
}
</script>
